/* eslint-disable quotes */
import ActionsForm from '@/shared/mixins/actionsForm'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpenses/mixins/ExpenseMixin.js'
import OcurrenceRepository from '@/shared/http/repositories/realestate/ocurrence'
import { Bar } from 'vue-chartjs'
import Chart from 'chart.js'
import { loading } from '@/shared/utils/UIHelper'
import VueHtml2pdf from 'vue-html2pdf'
import { values } from 'lodash'
// import localStoreHelper from '@/shared/utils/localStoreHelper.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'

import cabecalhoPng from '../../../../../../../static/img/realestate/relatorio/Header_horizontal.png'
import html2canvas from 'html2canvas'
// import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'

// ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

// eslint-disable-next-line no-unused-vars
var stringToColour = function (str) {
  var hash = 0
  for (var i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
  }
  var colour = '#'
  for (var j = 0; j < 3; j++) {
    var value = (hash >> (j * 8)) & 0xFF
    colour += ('00' + value.toString(16)).substr(-2)
  }
  return colour
}

export default {
  name: 'searchocurrence',
  plugins: [ChartDataLabels],
  mixins: [ActionsForm, ExpenseMixin],
  components: {
    Bar,
    VueHtml2pdf
  },
  props: {
    formSearch: {
      Type: Object,
      default: null
    },
    contapatologia: {
      Type: Number,
      default: null
    }
  },
  watch: {
    'formSearch': function () {
      this.GetPatologiasMaior()
    }
    // 'contapatologia': function (newvalue) {
    //   this.contapatologia = newvalue
    // }
  },
  data () {
    return {
      chartInstance: null,
      quantidadeOcorrencia: null,
      quantidadeOcorrenciaReal: null,
      periodoFiltro: null,
      StatusFiltro: null,
      dataInicio: null,
      imgCabecalhoZopone: cabecalhoPng,
      dataFim: null,
      patologias: [],
      empreedimentoArray: [],
      teste: [],
      resultado: {},
      patologiaMaior: null,
      hasChart: false,
      patologiasValues: [],
      Totalocorrencias: null,
      TotalEmpreendimento: null,
      imagem: null,
      patologiaPdfArray: [],
      patologiaArray: [],
      patologiaNamesArray: [],
      dataFormatada: null,
      GetPdf: null,
      dataRelatorio: null,
      dataInicioFormatado: null,
      dataFimFormatado: null,
      occurrencesLength: 0,
      patologiaEmpreendimento: '',
      occurrencesquantidade: 0
    }
  },
  mounted () {
    // var contapatologia = localStoreHelper.controleOcorrencia.contapatologia()
    // this.contapatologia = contapatologia
    // console.log(this.contapatologia)
    this.GetPatologiasMaior()
    this.GetPatologiasMaior()
    this.GetPatologiaValues()
    this.dataFormatadaPdf()
    this.GetPatologiaEnum()
  },
  methods: {
    verificaTamanhoEmpreendimento (value) {
      if (value != null) {
        if (value.length > 20) {
          return value.substring(0, 20) + "..."
        }
      }
      return value
    },
    dataFormatadaPdf () {
      var dataAtual = new Date()
      var ano = dataAtual.getFullYear()
      var mes = ('0' + (dataAtual.getMonth() + 1)).slice(-2)
      var dia = ('0' + dataAtual.getDate()).slice(-2)
      this.dataFormatada = dia + '/' + mes + '/' + ano
    },
    createImageHeaderFooter (imgHref) {
      const img = document.createElement("img")
      img.src = imgHref
      img.style.border = "none"
      return img
    },
    async abrirNovaGuia ({ html2pdf, options, pdfContent }) {
      const headerImage = new URL(this.imgCabecalhoZopone)
      const headerPdf = this.createImageHeaderFooter(headerImage.href)
      options.margin = [1, 0, 0.5, 0]
      html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages()
        for (let i = 1; i <= totalPages; i++) {
          pdf.addImage(headerPdf, 'Image-HTMLElement ', 0, 0, 12, 0)
          pdf.setPage(i)
          pdf.setFillColor(28, 98, 40)
          pdf.rect(0, pdf.internal.pageSize.getHeight() - 0.4, pdf.internal.pageSize.getWidth(), 10, 'F')
          pdf.setTextColor('#fff')
          pdf.setFont('Helvetica', 'normal') // Set font to normal for the next part
          pdf.setFontSize(10)
          pdf.text('Zopone - ', 0.2, pdf.internal.pageSize.getHeight() - 0.15)
          pdf.setFont('Helvetica', 'bold') // Set font back to bold
          pdf.text(
            'Relatório de Manutenção em Edificações  ' + this.dataRelatorio,
            0.9,
            pdf.internal.pageSize.getHeight() - 0.15
          )
          pdf.setFont('Helvetica', 'normal') // Set font to normal for the next part
          pdf.text(
            'Pág ',
            10.7,
            pdf.internal.pageSize.getHeight() - 0.15
          )
          pdf.setFont('Helvetica', 'bold')
          pdf.text(
            i + ' de ' + totalPages,
            11,
            pdf.internal.pageSize.getHeight() - 0.15
          )
        }
      }).save()
    },
    generatePDF () {
      this.$refs.html2Pdf.generatePdf()
    },

    closeModal () {
      this.$refs['popup-pdf-modal'].hide()
      this.imagem = null
    },
    openpopPdf () {
      this.$refs['popup-pdf-modal'].show()
      this.captureCanvasScreenshot()
      // this.captureCanvasLegends()
    },
    chart () {
      const container = document.querySelector('.chart-container')
      const legends = document.getElementById('legends')

      if (!this.resultado || Object.keys(this.resultado).length === 0) {
        console.warn("Dados do gráfico ainda não estão disponíveis.")
        return
      }

      const datasets = this.MontaPatologias()
      if (!datasets || datasets.length === 0) {
        console.warn("Nenhum dado para montar os datasets.")
        return
      }

      // Se já existir um gráfico, destrua-o antes de criar outro
      if (this.chartInstance !== null) {
        this.chartInstance.destroy()
      }

      // Remove o canvas antigo
      const oldCanvas = document.getElementById('myChart')
      if (oldCanvas) {
        oldCanvas.remove()
      }

      // Cria um novo canvas
      const newChart = document.createElement('canvas')
      newChart.id = 'myChart'
      container.appendChild(newChart)

      // Cria o novo gráfico
      this.chartInstance = new Chart(newChart, {
        plugins: [ChartDataLabels],
        type: 'bar',
        data: {
          labels: Object.keys(this.resultado),
          datasets: [...datasets]
        },
        options: {
          title: {
            display: true,
            text: `Período: (${this.GetPdf[0].dataInicio == null ? this.dataInicio : this.GetPdf[0].dataInicio} - ${this.GetPdf[0].dataFim == null ? this.dataFinal : this.GetPdf[0].dataFim})`,
            padding: 10,
            fontFamily: 'Poppins',
            fontSize: 18
          },
          scales: {
            yAxes: [{
              display: true,
              ticks: {
                beginAtZero: true,
                max: Math.ceil(this.patologiaMaior + (this.patologiaMaior * 0.1))
              }
            }],
            xAxes: [{ display: false }]
          },
          plugins: {
            datalabels: {
              color: 'white',
              display: function (context) {
                return context.dataset.data[context.dataIndex] > 0
              },
              font: {
                weight: 'bold',
                size: 16
              }
            }
          },
          legend: false,
          legendCallback: function (chart) {
            var div = document.createElement('div')
            div.setAttribute('id', 'legenda-grafico')
            div.style.display = 'flex'
            div.style.flexWrap = 'wrap'
            div.style.justifyContent = 'flex-start'
            div.style.fontFamily = 'Poppins'
            chart.data.datasets.forEach(function (label) {
              div.innerHTML += `
                <div style='display: flex; padding: 0.5rem; gap: 0.5rem; width:calc(25% - 1rem);'>
                  <div style='width: 20px; height: 20px; background-color:${label.backgroundColor}; cursor: pointer;'></div>
                  <span style='cursor: pointer;'>
                    <strong>${label.label} - ${label.data}</strong>
                  </span>
                </div>
              `
            })
            return div.outerHTML
          }
        }
      })

      // Atualiza a legenda
      legends.innerHTML = this.chartInstance.generateLegend()
    },

    MontaPatologias () {
      let retorno = []

      this.patologiaArray.forEach(p => {
        retorno.push({
          label: p.text,
          data: [...this.datasets[p.obj]],
          backgroundColor: stringToColour(p.text),
          minBarLength: 10
        })
      })
      this.teste = retorno
      return retorno
    },
    GetPatologiasMaior () {
      let parametros = this.formSearch
      loading.push()
      OcurrenceRepository.GetPatologiaMaior(parametros)
        .then((Response) => {
          loading.pop()
          this.patologiaMaior = Response.data.patologia
          if (this.patologiaMaior <= 4) {
            this.patologiaMaior = 5
          }
          this.GetPatologiaPdfs()
          if (parametros.periodoEnum === 1 || parametros.periodoEnum === 3) {
            this.GetPatologiasPesonalizadoSemanal()
          } else {
            this.GetPatologias()
          }
        })
        .catch((Error) => {
          console.log(Error)
          loading.pop()
        })
    },

    GetPatologiaPdfs () {
      let parametros = this.formSearch
      this.periodoFiltro = parametros.periodoEnum
      this.StatusFiltro = parametros.statusOcorrencia
      // this.dataInicio = parametros.dataInicio
      // this.dataFim = parametros.dataFinal
      this.verificaPeriodo()
      this.verificaStatus()
      this.GetEmpreendimentoPdf()
      this.GetPatologiasPdf()
      loading.push()
      OcurrenceRepository.GetPatologiaPdf(parametros)
        .then((Response) => {
          loading.pop()
          this.GetPdf = Response.data
          let arrayPatologia = Response.data.map(e => e.ocorrenciaByEmpreendimento.map(obj => obj.patologia))
          const count = this.countOccurrences(arrayPatologia)
          this.occurrencesLength = Object.keys(count).length
          let diaAtual = new Date()
          let dia = diaAtual.getDate()
          if (dia < 10) {
            dia = '0' + dia
          }
          let mes = diaAtual.getMonth() + 1
          if (mes < 10) {
            mes = '0' + mes
          }
          let ano = diaAtual.getFullYear()
          this.dataRelatorio = dia + '/' + mes + '/' + ano
          this.Totalocorrencias = this.GetPdf.length
          this.dataFim = this.GetPdf[0].dataFim
          this.dataInicio = this.GetPdf[0].dataInicio
          console.log(this.GetPdf)
          let quantidadeOcorrencia = this.GetPdf.map(item => item.qtaOcorrencias)
          this.quantidadeOcorrencia = quantidadeOcorrencia.reduce((acc, val) => acc + val, 0)
          this.quantidadeOcorrenciaReal = this.GetPdf.reduce((result, obj) => result + obj.ocorrenciaByEmpreendimento.length, 0)
        })
        .catch((Error) => {
          console.log(Error)
          loading.pop()
        })
    },

    countOccurrences (array) {
      const counts = {}

      // Iterate through each element in the array
      for (let i = 0; i < array.length; i++) {
        const innerArray = array[i]

        // Iterate through each element in the inner array
        for (let j = 0; j < innerArray.length; j++) {
          const element = innerArray[j]

          if (counts[element]) {
            counts[element]++
          } else {
            counts[element] = 1
          }
        }
      }

      return counts
    },
    GetEmpreendimentoPdf () {
      let parametros = this.formSearch
      loading.push()
      OcurrenceRepository.GetEmpreendimentoPdf(parametros)
        .then((Response) => {
          loading.pop()
          this.empreedimentoArray = Response.data
          this.TotalEmpreendimento = this.empreedimentoArray.length
        })
        .catch((Error) => {
          console.log(Error)
          loading.pop()
        })
    },

    GetPatologiasPdf () {
      let parametros = this.formSearch
      loading.push()
      OcurrenceRepository.GetPatologiasPdf(parametros)
        .then((Response) => {
          loading.pop()
          this.patologiaPdfArray = Response.data
        })
        .catch((Error) => {
          console.log(Error)
          loading.pop()
        })
    },

    formataData (value) {
      if (value != null) {
        var dia = value.getDate()
        var mes = value.getMonth() + 1
        var ano = value.getFullYear()
        var dataFormatada = dia.toString().padStart(2, '0') + '/' + mes.toString().padStart(2, '0') + '/' + ano
        return dataFormatada
      } else {
        return 'N/D'
      }
    },

    verificaPeriodo () {
      if (this.periodoFiltro === 0) {
        this.periodoFiltro = 'MENSAL'
      } else if (this.periodoFiltro === 1) {
        this.periodoFiltro = 'SEMANAL'
      } else if (this.periodoFiltro === 2) {
        this.periodoFiltro = 'ANUAL'
      } else {
        this.periodoFiltro = 'PERSONALIZADO'
      }
    },

    verificaStatus () {
      const labels = {
        '3': 'CONCLUÍDO',
        '-1': 'CANCELADO',
        '1': 'AG. VISTORIA TÉCNICA',
        '2': 'EM ANDAMENTO'
      }
      const arr = Array.isArray(this.StatusFiltro)
        ? this.StatusFiltro
        : (this.StatusFiltro != null ? [this.StatusFiltro] : [])
      if (arr.length === 0) {
        this.StatusFiltro = 'N/D'
        return
      }
      this.StatusFiltro = arr.map(s => labels[String(s)] || 'N/D').join(', ')
    },

    GetPatologiasPesonalizadoSemanal () {
      let parametros = this.formSearch
      loading.push()
      this.hasChart = true
      OcurrenceRepository.GetPatologiasPesonalizadoSemanal(parametros)
        .then((Response) => {
          loading.pop()
          this.patologias = Response.data
          const patologias = this.patologiasValues
          if (this.patologias.length === 0) {
            // Se já existir um gráfico, destrua-o antes de criar outro
            if (this.chartInstance !== null) {
              this.chartInstance.destroy()
            }

            this.hasChart = false
          }

          this.resultado = {}

          this.patologias.forEach(x => {
            if (!(x.periodo in this.resultado)) {
              this.resultado[x.periodo] = {}
              // eslint-disable-next-line no-return-assign
              patologias.forEach(p => this.resultado[x.periodo][p] = 0)
            }
            this.resultado[x.periodo][x.patologia] += x.quantidadeOcorrencia

            // this.resultado[x.periodo] = {}
            // this.resultado[x.periodo][x.patologia] = x.quantidadeOcorrencia
            // console.log(this.resultado)
          })

          const periodos = Object.keys(this.resultado)
          const datasets = {}

          // eslint-disable-next-line no-return-assign
          patologias.forEach(p => datasets[p] = [])

          let maiorQuantidade = 0

          periodos.forEach(a => {
            if (maiorQuantidade < Object.keys(this.resultado[a]).length) {
              maiorQuantidade = Object.keys(this.resultado[a]).length
            }
            for (const key in this.resultado[a]) {
              datasets[key].push(this.resultado[a][key])
            }
            this.datasets = datasets
            this.$nextTick(() => {
              this.chart()
            })
          })

          loading.pop()
        })
        .catch((Error) => {
          console.log(Error)
          loading.pop()
        })
    },

    GetPatologias () {
      let parametros = this.formSearch
      loading.push()
      this.hasChart = true
      OcurrenceRepository.GetPatologias(parametros)
        .then((Response) => {
          loading.pop()
          this.patologias = Response.data
          const patologias = this.patologiasValues
          if (this.patologias.length === 0) {
            // Se já existir um gráfico, destrua-o antes de criar outro
            if (this.chartInstance !== null) {
              this.chartInstance.destroy()
            }
            this.hasChart = false
            return
          }

          this.resultado = {}

          this.patologias.forEach(x => {
            if (!(x.periodo in this.resultado)) {
              this.resultado[x.periodo] = {}
              // eslint-disable-next-line no-return-assign
              patologias.forEach(p => this.resultado[x.periodo][p] = 0)
            }
            this.resultado[x.periodo][x.patologia] += 1
          })

          const periodos = Object.keys(this.resultado)
          const datasets = {}

          // eslint-disable-next-line no-return-assign
          patologias.forEach(p => datasets[p] = [])

          let maiorQuantidade = 0

          periodos.forEach(a => {
            if (maiorQuantidade < Object.keys(this.resultado[a]).length) {
              maiorQuantidade = Object.keys(this.resultado[a]).length
            }
            for (const key in this.resultado[a]) {
              datasets[key].push(this.resultado[a][key])
            }
            this.datasets = datasets
            this.$nextTick(() => {
              this.chart()
            })
          })
          loading.pop()
        })
        .catch((Error) => {
          loading.pop()
          console.log(Error)
        })
    },
    GetPatologiaValues () {
      OcurrenceRepository.GetPatologiaValue()
        .then(Response => {
          let array = Response.data

          let novoArray = array.map(x => values(x)[0])
          // let novoArray = array._map({ array }, function (num) { return num })
          this.patologiasValues = novoArray
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
        })
    },
    GetPatologiaEnum () {
      loading.push()
      OcurrenceRepository.GetPatologia()
        .then(Response => {
          // var teste = Response.data.forEach((element) => {
          //   console.log(element)
          // })
          this.patologiaArray = Response.data
          this.patologiaNamesArray = this.patologiaArray.map((element, index) => {
            return element.text
          })

          // this.patologiaNamesArray = namedArray
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
        })
    },
    async captureCanvasScreenshot () {
      // Crie um elemento <canvas> temporário para desenhar a imagem
      const canvasElement = document.getElementById('myChart')
      const legendCanvas = await html2canvas(document.querySelector('#legends'))
      const tempCanvas = document.createElement('canvas')
      const tempContext = tempCanvas.getContext('2d')
      tempCanvas.width = canvasElement.width
      tempCanvas.height = canvasElement.height + legendCanvas.height
      tempContext.drawImage(canvasElement, 0, 0)
      tempContext.drawImage(legendCanvas, 0, canvasElement.height)
      // tempContext.drawImage(legendCanvas, 0, canvasElement)
      // const canvasLegend = document.getElementById('legends')

      // Defina o tamanho do canvas temporário igual ao canvas original
      // Desenhe a imagem do canvas original no canvas temporário
      // Crie um objeto de imagem para a captura
      const screenshot = new Image()
      // Atribua o conteúdo do canvas temporário à imagem
      screenshot.src = tempCanvas.toDataURL('image/png')
      this.imagem = screenshot
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/reports/components/chartReports/chartReports.js